 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		54: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		54: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"7":"DeprecatedStyles","15":"EnhancedStyles","16":"app-components-Workflow-WorkflowContainer","17":"app-components-bibs-BibPage-BibPageContainer","18":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","19":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","20":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","21":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","22":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","23":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","24":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","25":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","26":"app-components-bibs-subpages-CommentPage-CommentPageContainer","27":"app-components-bibs-subpages-MarcPage-MarcPageContainer","28":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","29":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","30":"app-components-bibs-subpages-VideoPage-VideoPageContainer","31":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","32":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","33":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","34":"app-components-borrowing-fines-Fines-FinesContainer","35":"app-components-borrowing-fines-GlobalPaymentsPage","36":"app-components-borrowing-holds-Holds-HoldsContainer","37":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","39":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","41":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","42":"app-components-events-EventsSearchPage-EventsSearchPageContainer","43":"app-components-events-MyEventsPage-MyEventsPageContainer","44":"app-components-info-apps-UnregisterPage","45":"app-components-list-ListPageContainer","46":"app-components-locations-LocationsPage-LocationsPage","47":"app-components-search-Search-SearchContainer","48":"app-components-search-SearchPrintList-SearchPrintListContainer","49":"app-components-settings-account-UnregisterPage","50":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","51":"app-components-shelves-Shelf-ShelfContainer","52":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","53":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"dfaaa1bac6e176be2adf","1":"3747aabc5439e973dd3b","2":"673657145912daeb6e34","3":"17829f4f964d0730efad","4":"71b21b4177d4d5ebeee0","5":"bc67edb85a4bc27212de","6":"728bfece0515ffb1240c","7":"577263b1450bf787474d","8":"ee40a2b1f147e76533f7","9":"e5aad3e951131c990b47","10":"458d8410f7c7bacf672f","11":"604f4691c3f1f53399e8","12":"e5d61bf9e11a3fe9094d","13":"a1d6336a0e9e61aeeb78","14":"a537e1b75160b6fa7218","15":"5446b682d62cf59db31f","16":"6fd9ede8f52c3de2be01","17":"313f877ed74a4022f926","18":"93ea12cd7e6ef6e36f28","19":"f1426035d13721dc9635","20":"959120d76e12796ba4dd","21":"c4c564263d691f3a8549","22":"953f05be273727fd68ae","23":"5cb48849791636cc0811","24":"66965cc9e89abe17465f","25":"79f8d06881c7c27427e3","26":"04bc2d9ce4072d60c169","27":"8203b4f40a6bcb12fdc1","28":"892509a9ad88b03a979a","29":"2b79b78f3e0740e205e9","30":"9491ecdb6f42152d74d0","31":"e1a48087dd952306fd61","32":"0d0b1ff43772965a041a","33":"ce7d7e37c75274994db6","34":"c758cd76f7f5e855bcb0","35":"b44988ce75c2719d7a69","36":"7870794e2148b4323311","37":"dbc2929caf583ac47cd8","38":"822ed0ad487914d43cb6","39":"edbed2ac853da6db8cf0","40":"74946b5bb3b661a0d25e","41":"d510fd154e8fb9d8a2a2","42":"9654fb8a487557370ecc","43":"3daa3866dcda9f9e36a5","44":"c78a002c3c8e86ed08c7","45":"e38c7427a1a9801ea752","46":"97174217290bcf8ea69b","47":"e78620e69e6a1aa0a899","48":"89b58bb48b0f2ddcf2a7","49":"0e74188c72982fc72d24","50":"b498a1fea8b109a21176","51":"bcdc74e42409c1258a89","52":"a27c7e9fe8113df08782","53":"1ee663bd44bb2b676fdf","55":"073982c4c9b9dc382c8c","56":"f7839591efcc104e0a3a","57":"38f4b09b6450ecfb9115","58":"14bc03cc05844eb99e44"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"55":1,"56":1,"57":1,"58":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"7":"DeprecatedStyles","15":"EnhancedStyles","16":"app-components-Workflow-WorkflowContainer","17":"app-components-bibs-BibPage-BibPageContainer","18":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","19":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","20":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","21":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","22":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","23":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","24":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","25":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","26":"app-components-bibs-subpages-CommentPage-CommentPageContainer","27":"app-components-bibs-subpages-MarcPage-MarcPageContainer","28":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","29":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","30":"app-components-bibs-subpages-VideoPage-VideoPageContainer","31":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","32":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","33":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","34":"app-components-borrowing-fines-Fines-FinesContainer","35":"app-components-borrowing-fines-GlobalPaymentsPage","36":"app-components-borrowing-holds-Holds-HoldsContainer","37":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","39":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","41":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","42":"app-components-events-EventsSearchPage-EventsSearchPageContainer","43":"app-components-events-MyEventsPage-MyEventsPageContainer","44":"app-components-info-apps-UnregisterPage","45":"app-components-list-ListPageContainer","46":"app-components-locations-LocationsPage-LocationsPage","47":"app-components-search-Search-SearchContainer","48":"app-components-search-SearchPrintList-SearchPrintListContainer","49":"app-components-settings-account-UnregisterPage","50":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","51":"app-components-shelves-Shelf-ShelfContainer","52":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","53":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"dfaaa1bac6e176be2adf","1":"3747aabc5439e973dd3b","2":"673657145912daeb6e34","3":"17829f4f964d0730efad","4":"71b21b4177d4d5ebeee0","5":"bc67edb85a4bc27212de","6":"728bfece0515ffb1240c","7":"577263b1450bf787474d","8":"ee40a2b1f147e76533f7","9":"e5aad3e951131c990b47","10":"458d8410f7c7bacf672f","11":"604f4691c3f1f53399e8","12":"e5d61bf9e11a3fe9094d","13":"a1d6336a0e9e61aeeb78","14":"a537e1b75160b6fa7218","15":"5446b682d62cf59db31f","16":"6fd9ede8f52c3de2be01","17":"313f877ed74a4022f926","18":"93ea12cd7e6ef6e36f28","19":"f1426035d13721dc9635","20":"959120d76e12796ba4dd","21":"c4c564263d691f3a8549","22":"953f05be273727fd68ae","23":"5cb48849791636cc0811","24":"66965cc9e89abe17465f","25":"79f8d06881c7c27427e3","26":"04bc2d9ce4072d60c169","27":"8203b4f40a6bcb12fdc1","28":"892509a9ad88b03a979a","29":"2b79b78f3e0740e205e9","30":"9491ecdb6f42152d74d0","31":"e1a48087dd952306fd61","32":"0d0b1ff43772965a041a","33":"ce7d7e37c75274994db6","34":"c758cd76f7f5e855bcb0","35":"b44988ce75c2719d7a69","36":"7870794e2148b4323311","37":"dbc2929caf583ac47cd8","38":"822ed0ad487914d43cb6","39":"edbed2ac853da6db8cf0","40":"74946b5bb3b661a0d25e","41":"d510fd154e8fb9d8a2a2","42":"9654fb8a487557370ecc","43":"3daa3866dcda9f9e36a5","44":"c78a002c3c8e86ed08c7","45":"e38c7427a1a9801ea752","46":"97174217290bcf8ea69b","47":"e78620e69e6a1aa0a899","48":"89b58bb48b0f2ddcf2a7","49":"0e74188c72982fc72d24","50":"b498a1fea8b109a21176","51":"bcdc74e42409c1258a89","52":"a27c7e9fe8113df08782","53":"1ee663bd44bb2b676fdf","55":"073982c4c9b9dc382c8c","56":"f7839591efcc104e0a3a","57":"38f4b09b6450ecfb9115","58":"14bc03cc05844eb99e44"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2340);
